import type { FaireProductEntity } from "../../entity_types/product";

export const p_xrdpdgf7ux: FaireProductEntity = {
  token: "p_xrdpdgf7ux",
  type: "product",
  name: "Curved Bezel Asscher Moissanite Band Ring 925 Silver",
  brandToken: "b_mpb8yp79mh",
  brandName: "GEMPARA",
  imageUrl: "https://cdn.faire.com/fastly/9251aa6faf818c5d81391f310f31b9b2505da995e0d944f1bb558dc4b499cc9f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6013b26dcf2f8abc81a9bef9be2926f7a9ac12302c271dcf5f7170c1d15bb6bb.jpeg",
    "https://cdn.faire.com/fastly/542ac282609eeda2df02eacd2feef4049165636c667d50c57a0ee58e84656431.jpeg",
    "https://cdn.faire.com/fastly/821fbcd6e43d731ddca6de3314998588b840310d0d4713c82718ab27c401aa28.png"
  ],
  priceDollars: 83.13,
  description: "Curved Bezel Moissanite Band – 1.2mm Band / 3mm Stones\n\nA refined curved stacking band designed for modern bridal and everyday layering. This elegant ring features a row of 3mm step-cut moissanites in clean bezel settings, set along a gentle contour that pairs beautifully with engagement rings or can be worn alone as a minimalist statement.\n\nThe slim 1.2mm band keeps the silhouette delicate and lightweight, while the bezel-set stones offer a smooth, secure finish ideal for daily wear. The geometric sparkle of the step-cut moissanite gives this piece a sophisticated, mirror-like brilliance.\n\nStone Details\n\nStone Type: Moissanite\n\nStone Shape: Step-cut (Asscher/Emerald-style appearance)\n\nStone Size: 3mm each\n\nColor Grade: D (Colorless)\n\nClarity: VVS1\n\nCut: Excellent\n\nSetting Type: Bezel setting\n\nRing Details\n\nBand Width: 1.2mm\n\nStyle: Curved contour band / stacking band / wedding band\n\nWearability: Designed to stack with solitaires and low-to-medium profile engagement rings\n\nA versatile bridal and fashion piece with a clean architectural look—perfect for customers seeking a modern alternative to traditional pavé bands.",
  tags: [],
  msrpDollars: 166.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:28.834Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
